<!--视频组件-->
<!--wj-->
<template>
    <div class="VideoBar">
        <video 
        ref="video"
        id="video"
        webkit-playsinline='true'
        playsinline='true'
        x5-playsinline = 'true'
        x-webkit-airplay="allow"
        controls
        controlslist="nodownload"
        poster="../assets/image/poster.png"
        :autoplay="false"
        >
        </video>
    </div>
</template>
<script>
import { eventBus } from '@/assets/js/eventBus';
export default {
    name: "TestTwo",
    data() {
        return {
            showbar: false,
            url: "",
            name: "",
            type:'',
        };
    },
    mounted() {
        const that = this;
        var src = "";
        eventBus.$on("fileUrl",(val) => {
            this.$refs.video.src = val.url;
            that.url = val.url;
            that.name = val.name;
            this.$refs.video['disablePictureInPicture'] = true;
        });
        $(".VideoBar").css('padding-top','5.1rem')
        $('video').addClass("videoStyle");
        $('#video').css('height',screen.width/1.78);
        document.addEventListener('webkitfullscreenchange', function() {
            var el = document.webkitFullscreenElement; //获取全屏元素  
            if(el) {  
                plus.screen.lockOrientation('landscape'); //锁死屏幕方向为横屏
                that.type='横屏';
                that.showbar = true;
            } else {  
                plus.screen.lockOrientation('portrait'); //解除屏幕方向的锁定
                that.type='竖屏';
                that.showbar = false;
            }  
        });
    },
};
</script>
<style>
.videoStyle{
    width:100%;
    height: auto;
}
video{
    z-index:3000;
    background:black;
}
.setmore{
    padding: 1rem;
    position: absolute;
    color: #ffffff;
    z-index: 9999;
    font-size: 1.5rem;
}
/* video::-webkit-media-controls-panel */
</style>
